import Home from "./pages/Home.vue";
import Work from "./pages/Work.vue";
import Contact from "./pages/Contact.vue";
import Resume from "./pages/Resume.vue";
import Workitem from "@/components/WorkItem.vue";


export function createRoutes(workItems) {
  const websiteRoutes = workItems.map(site => {
    return {
      path: `/work/${site.title.replace(/\s+/g, "-").toLowerCase()}`,
      component: Workitem,
      name: site.title,
      meta: site
    };
  });
  return [
    {
      path: "/",
      component: Home,
      name: "home"
    },
    {
      path: "/work",
      component: Work,
      name: "work",
      children: websiteRoutes
    },
    {
      path: "/contact",
      component: Contact,
      name: "contact"
    },
    {
      path: "/resume",
      component: Resume,
      name: "resume"
    },
    {
      path: "*",
      redirect: "/"
    }
  ];
}